import {
    requestPublic,
    request
} from './request.js'

// 获取学生住宿安排
export function getStudentAccommodationList() {
    return request({
        url: '/api2/StudentAccommodationApi/StudentAccommodation/GetStudentAccommodationList',
        method: 'get',
    })
}
// 评价公寓
export function AddAccommodationEvaluation(obj) {
    return request({
        url: '/api2/StudentAccommodationApi/StudentAccommodation/AddAccommodationEvaluation',
        method: 'get',
        params:{
            studentAccommodationId: obj.id,
            evaluationSorce: obj.score,
            evaluationContent: obj.evaluationNote,
        }
    })
}
// 获取房屋到租页信息
export function getStudentAccommodationInfo(id) {
    return request({
        url: '/api2/StudentAccommodationApi/StudentAccommodation/StudentAccommodationInfo',
        method: 'get',
        params:{
            studentAccommodationId:id
        }
    })
}
// 在线退租申请
export function postStudentAccRefund(data) {
    return request({
        url: '/api2/StudentAccommodationApi/StudentAccommodation/StudentAccRefund',
        method: 'post',
        params:{
            studentAccommodationId:data.studentAccommodationId,
            RefundTime:data.RefundTime,
            money:data.money
        }
    })
}
// 在线续租申请
export function postStudentAccContinue(data) {
    return request({
        url: '/api2/StudentAccommodationApi/StudentAccommodation/StudentAccContinue',
        method: 'post',
        params:{
            studentAccommodationId:data.studentAccommodationId,
            monthNum:data.monthNum,
            insurance:data.insurance
        }
    })
}